"use client";

import React from "react";
import { OpeningsLogo, type OpeningsLogoSize } from "./OpeningsLogo";

export interface PoweredByOpeningsProps {
  size?: OpeningsLogoSize;
  label?: string;
  href?: string;
  ariaLabel?: string;
  className?: string;
  style?: React.CSSProperties;
  textStyle?: React.CSSProperties;
}

const TEXT_COLOR = "var(--openings-color-text-muted, rgba(0, 0, 0, 0.45))";

function PoweredByOpenings({
  label = "Powered by Openings",
  href = "https://openings.link",
  ariaLabel = "Openings",
  className,
  style,
  textStyle,
}: PoweredByOpeningsProps) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={ariaLabel}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        lineHeight: 0,
        ...style,
      }}
    >
      <OpeningsLogo size={"sm"} showWordmark={false} />

      {label ? (
        <span
          style={{
            fontSize: 12,
            color: TEXT_COLOR,
            ...textStyle,
          }}
        >
          {label}
        </span>
      ) : null}
    </a>
  );
}

export default PoweredByOpenings;
